var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"choose-theme-sec"},[_c('chat-sidebar'),_c('div',{staticClass:"main-content main-chat-content popup-chat"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }